import React from 'react';
import { Box, Anchor, Text, ThemeContext } from 'grommet';
import { Code } from 'grommet-icons';

const theme = {
  anchor: {
    color: 'dark-1',
    textDecoration: 'underline dotted',
    hover: {
      textDecoration: 'underline dotted'
    }
  }
};

const CodeSandboxCard = ({ sandboxUrl, projectTitle }) => (
  <ThemeContext.Extend value={theme}>
    <Box alignSelf="center">
      <Anchor href={sandboxUrl}>
        <Box direction="row" width="medium" background="light-1">
          <Box pad="small" direction="row" background="accent-1">
            <Code color="dark-1" />
          </Box>
          <Box margin={{ right: 'small' }} pad="small">
            <Text size="small" margin={{ right: 'xsmall' }}>
              {`View ${projectTitle} on Codesandbox`.toUpperCase()}
            </Text>
          </Box>
        </Box>
      </Anchor>
    </Box>
  </ThemeContext.Extend>
);

export default CodeSandboxCard;
